import styled from 'styled-components'

export const Title = styled.h2`
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 20px;
  color: #303030;
`

export const Button = styled.button<{ variant?: 'primary' | 'outline' }>`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 24px;
  border-radius: 20px;
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  cursor: pointer;
  
  ${props => props.variant === 'primary' ? `
    background-color: #0090D3;
    color: #FFFFFF;
    border: none;
  ` : `
    background-color: #FFFFFF;
    color: #0090D3;
    border: 1px solid #0090D3;
  `}
`

export const Card = styled.div`
  background-color: #FFFFFF;
  border-radius: 16px;
  border-left: 1px solid #f4f4f4;
  padding: 20px;
  width: 100%;
  margin-bottom: 1rem;
`

export const FormGrid = styled.div`
  display: flex;
  gap: 32px;
  margin-bottom: 20px;
  margin-top: 16px;
`

export const FormGroup = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const Label = styled.label`
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  color: #303030;
`

export const Select = styled.select`
  padding: 10px 16px;
  background-color: #EBEBEB;
  border: none;
  border-radius: 20px;
  color: #696969;
  font-family: 'Inter', sans-serif;
  outline: none;
`

export const InfoLink = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: #0090D3;
  font-family: 'Inter', sans-serif;
  cursor: pointer;
`

export const Separator = styled.hr`
  border: none;
  height: 1px;
  background-color: #EBEBEB;
  margin: 20px 0;
`

export const CollapsibleHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
`

export const Summary = styled.div`
  display: flex;
  gap: 32px;
`

export const SummaryItem = styled.div`
  flex: 1;
  display: flex;
  gap: 8px;
`

export const SummaryLabel = styled.span`
  font-family: 'Inter', sans-serif;
  color: #696969;
  white-space: nowrap;
`

export const SummaryValue = styled.span`
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  color: #303030;
  flex: 1;
`

export const AddProductContainer = styled.div`
  margin-top: 16px;
`

export const AddButton = styled.div`
    width: 13.9vw;
    height: 5.9vh;
    border-radius: 20px;
    border: 1px solid #0090D3;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    margin: 20px auto;
`

export const AddButtonImg = styled.img`
    width: 0.8vw;
    height: 1.7vh;
    color: #0090D3;
`

export const AddButtonText = styled.p`
    font-family: 'Inter', sans-serif;
    font-weight: 700;
    font-size: 1rem;
    color: #0090D3
`

export const BreadCrumble = styled.div`
    display: flex;
    gap: 8px;
    margin-bottom: 1rem;
`
export const FirstText = styled.p`
    font-family: 'Inter', sans-serif;
    font-weight: 400;
    size: 1rem;
    color: #0090D3;
`

export const SecondText = styled.p`
    font-family: 'Inter', sans-serif;
    font-weight: 400;
    size: 1rem;
    color: #696969
`

export const MoreInformation = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  margin-top: 8px;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 23vw;
  height: 29vh;
  padding: 12px;
  border-radius: 0 16px 16px 16px;
  border: 1px solid #EBEBEB;
  background-color: #FFFFFF;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.08);
  z-index: 10;
`

export const InfoName = styled.p`
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #696969;
  display: flex;
  gap: 16px;
  height: 21px;
`

export const InfoValue = styled.p`
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #303030;
`

export const ProductShort = styled.div`
    display: flex;
    align-items: center;
`

export const ProductDiv = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    padding-left: 0.5rem;
`


export const ActionsDiv = styled.div`
    display: flex;
    gap: 32px;
    padding-left: 2rem;
`

export const InputText = styled.input`
  padding: 10px 16px;
  background-color: #EBEBEB;
  border: none;
  border-radius: 20px;
  color: #696969;
  font-family: 'Inter', sans-serif;
  outline: none;
`

export const ShortLabel = styled.label`
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  color: #303030;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const FileUploadContainer = styled.div`
  display: flex;
  align-items: center;
  border-radius: 20px;
  background-color: #ebebeb;
  padding: 8px 12px;
  width: 100%;
  max-width: 390px;
`

export const FileUploadLabel = styled.label`
  background-color: #fff;
  border-radius: 4px;
  padding: 3px 6px;
  cursor: pointer;
  margin-right: 8px;
  white-space: nowrap;
  font-size: 0.8rem;
`

export const FileNameText = styled.span`
  color: #666;
  font-size: 0.8rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
`

export const AttachmentsContainer = styled.div`
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 12px;
  background-color: #f8f9fa;
  margin-top: 8px;
`

export const NoAttachmentsText = styled.div`
  color: #666;
  font-style: italic;
  padding: 8px;
`

export const AttachmentItemRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px;
  border-radius: 4px;
  margin-bottom: 8px;
`

export const ExistingAttachmentItem = styled(AttachmentItemRow)`
  background-color: #fff;
  border: 1px solid #e9ecef;
`

export const NewAttachmentItem = styled(AttachmentItemRow)`
  background-color: #e7f3ff;
  border: 1px dashed #007bff;
`

export const AttachmentInfoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const AttachmentNameLink = styled.a`
  color: #007bff;
  text-decoration: none;
  cursor: pointer;
  
  &:hover {
    text-decoration: underline;
  }
`

export const AttachmentFileSize = styled.span`
  color: #6c757d;
  font-size: 12px;
`

export const AttachmentActionsContainer = styled.div`
  display: flex;
  gap: 8px;
`

export const AttachmentActionButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  font-size: 12px;
  font-weight: bold;
  padding: 0;
  
  &:hover {
    opacity: 0.8;
  }
`

export const DownloadButton = styled(AttachmentActionButton)`
  color: #007bff;
`

export const RemoveButton = styled(AttachmentActionButton)`
  color: #dc3545;
`

export const FlexContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`



export const AttachmentsSection = styled.div`
  margin-top: 20px;
`

export const AttachmentListContainer = styled.div`
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 12px;
  background-color: #f8f9fa;
  margin-top: 8px;
`

export const AttachmentItem = styled.div<{ isNew?: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px;
  background-color: ${props => props.isNew ? '#e7f3ff' : '#fff'};
  border-radius: 4px;
  margin-bottom: 8px;
  border: 1px ${props => props.isNew ? 'dashed #007bff' : 'solid #e9ecef'};
`

export const AttachmentIcon = styled.span`
  margin-right: 8px;
`

export const AttachmentDetails = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const AttachmentName = styled.span`
  font-family: 'Inter', sans-serif;
  color: #303030;
  cursor: pointer;
  
  &:hover {
    text-decoration: underline;
  }
`

export const AttachmentLink = styled.a`
  font-family: 'Inter', sans-serif;
  color: #007bff;
  cursor: pointer;
  text-decoration: none;
  
  &:hover {
    text-decoration: underline;
  }
`

export const FlexRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const ConditionPaymentContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const ConditionPaymentSelect = styled(Select)`
  flex-grow: 1;
`

export const ConditionPaymentInput = styled(InputText)`
  flex-grow: 1;
`

export const PlusIconContainer = styled.div`
  cursor: pointer;
  min-width: 16px;
`

export const ProductFieldsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 32px;
  padding-left: 2rem;
`

export const ProductFieldLabel = styled.span`
  font-weight: normal;
  margin-left: 0.5rem;
`